module.exports = __webpack_public_path__ + "img/tick.284adedc.svg";